import './StriveVision.scss';
import Component from './StriveVision.js';
export default Component;